"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _text = require("@mmc/text");
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _navigationHeader = _interopRequireDefault(require("../styles/navigation-header.css"));
var dataUtils = new _mmcDataUtilities["default"]();
var isEmptyArray = dataUtils.isEmptyArray;
var clickHandler = function clickHandler(innerLabel, nameplateLabel, label, name) {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'navclick',
      component: 'top_nav',
      action: "inner_link",
      section_name: name,
      inner_section: innerLabel,
      nameplate: nameplateLabel,
      click_text: label
    });
  }
};
var PromotionLink = function PromotionLink(_ref) {
  var layoutType = _ref.layoutType,
    mobileNavActive = _ref.mobileNavActive,
    imageWithText = _ref.imageWithText,
    disclaimerData = _ref.disclaimerData,
    name = _ref.name;
  var promoInTwoColumn = imageWithText && !isEmptyArray(imageWithText) && imageWithText.length === 2;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _navigationHeader["default"][layoutType] + " " + _navigationHeader["default"].promoWrapper + " " + (promoInTwoColumn === true && mobileNavActive === false ? _navigationHeader["default"].promoInTwoColumn : '')
  }, imageWithText && !isEmptyArray(imageWithText) && imageWithText.map(function (promoItem) {
    var _promoItem$image;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "" + _navigationHeader["default"].promotionCard
    }, /*#__PURE__*/_react["default"].createElement("img", {
      className: _navigationHeader["default"].promtionCardImage,
      src: (_promoItem$image = promoItem.image) == null ? void 0 : _promoItem$image.image,
      alt: "MMC"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "" + _navigationHeader["default"].promotionCardText
    }, /*#__PURE__*/_react["default"].createElement(_text.Text, {
      text: promoItem.heading1,
      className: _navigationHeader["default"].labelText,
      tag: "div",
      disclaimerData: disclaimerData
    }), /*#__PURE__*/_react["default"].createElement(_text.Text, {
      text: promoItem.heading2,
      className: _navigationHeader["default"].promotionCardHeading,
      tag: "div",
      disclaimerData: disclaimerData
    }), /*#__PURE__*/_react["default"].createElement(_text.Text, {
      text: promoItem.heading3,
      className: _navigationHeader["default"].promotionCardDescription,
      tag: "div",
      disclaimerData: disclaimerData
    }), promoItem.ctasWithColor && imageWithText && !isEmptyArray(promoItem.ctasWithColor) && promoItem.ctasWithColor.map(function (item) {
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("a", {
        className: _navigationHeader["default"][item.backgroundCTA] + " " + _navigationHeader["default"].roundLinks,
        href: item.link,
        onClick: function onClick() {
          return clickHandler(promoItem.heading1, promoItem.heading2, item.label, name);
        }
      }, item.label));
    })));
  }));
};
PromotionLink.displayName = 'PromotionLink';
var _default = PromotionLink;
exports["default"] = _default;